<script>

export default {
  props: ['item', 'isnew'],
  data() {
    return {
      loading: true,
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        wheres: {
          website_id: '',
        },
      },
      website: {},

      locations: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'District Of Columbia',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming',
      ],
      categories: [
        'General',
        'Selling',
        'Buying',
        'Mortgage',
        'Insurance',
        'Title',
        'Moving',
        'New build',
        'Renovation',
        'Repairs',
        'Carpet cleaning',
        'Home cleaning',
        'Staging',
        'Home warranty',
        'Inspections',
        'Landscaping',
        'Painters',
        'Secuity',
        'Storage',
      ],
    }
  },
  watch: {
    'item.website': { handler: function(n, o) {
      this.filters.wheres.website_id = n;
      this.fetchData();
    }, immediate: true },
  },
  created() {

  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/websites/fetch', {params: this.filters}).then(res => {
        if(res.data.data.length == 1) {
          this.website = res.data.data[0];
        } else {
          this.$noty.warning("Vendor categories and locations could not be found.");
        }
        this.filters.total = res.data.total;
        this.loading = false;
      }).catch(res => { this.loading = false; this.popupErrors(res); });
    },
  }
}
</script>

<template>
  <div>
    <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Vendor details :</h5>
    <div class="row">
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.status" :Options="[{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]" Title="Live :" Required></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String List, Single" v-model="item.website" :Options="app_website_ids" Title="Website :" required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="Title :" v-model="item.title" Required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="Textarea" Title="Summary :" v-model="item.summary" Max="475" Required></w-field>
      </div>
      <div class="col-sm-12">
        <w-field SimpleDataType="String" Title="Thumbnail :" v-model="item.thumbnail"></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Multi" Title="Locations :" v-model="item.locations" :Options="website.vendor_locations"></w-field>
      </div>
      <div class="col-sm-6">
        <w-field SimpleDataType="String List, Multi" Title="Categories :" v-model="item.categories" :Options="website.vendor_categories"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Email address :" v-model="item.email"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="Phone" Title="Phone number :" v-model="item.phone"></w-field>
      </div>
      <div class="col-sm-4">
        <w-field SimpleDataType="String" Title="Website URL :" v-model="item.url"></w-field>
      </div>
      <div class="col-sm-12">
        <div role="group" class="form-group">
          <label for="input-content" class="d-block">Description :</label>
          <CkRichEditor v-model="item.content"></CkRichEditor>
        </div>
      </div>
    </div>

    <div class="clearfix mt-3"></div>

  </div>
</template>
